module.exports = __webpack_public_path__ + "static/media/barbuda-18.7bc9d487.jpg";